import { logEvent, setUserId, getAnalytics, setUserProperties } from "firebase/analytics";
import { AppPlatform, AnalyticsEventType } from "app/types";

/**
 * ネイティブの Firebase に渡すか。Amazon 版のアプリはネイティブの Firebase が使えないので、
 * WebView の中でも Web の Firebase で送る
 */
export const usesNativeAnalytics = () =>
  !!window.ReactNativeWebView && window.parentsAppPlatform !== AppPlatform.Amazon;

const postNative = (command: string, data: object) => {
  window.ReactNativeWebView.postMessage(JSON.stringify({ command, data }));
};

const withPage = (params?: object) => ({
  ...params,
  page_path: location.pathname,
  page_title: location.pathname,
});

/**
 * イベントを GA に送る。アプリ（WebView）ではネイティブの Firebase に渡す（Amazon 版を除く）。
 * React の外からも呼べるように、hook にしていない。
 */
export const recordEvent = (type: AnalyticsEventType | string, params?: object) => {
  try {
    if (usesNativeAnalytics()) {
      postNative("logEvent", { event: type, params: withPage(params) });
    } else {
      logEvent(getAnalytics(), type, withPage(params));
    }
  } catch (error) {
    console.warn("recordEvent error:", error);
  }
};

/** GA のユーザー ID。保護者の uid */
export const setAnalyticsUserId = (uid: string) => {
  try {
    if (usesNativeAnalytics()) {
      postNative("setUserId", { uid });
    } else {
      setUserId(getAnalytics(), uid);
    }
  } catch (error) {
    console.warn("setAnalyticsUserId error:", error);
  }
};

/** GA のユーザープロパティ。plan は保護者のアカウントのプラン */
export const setAnalyticsUserProperties = (properties: { plan: string }) => {
  try {
    if (usesNativeAnalytics()) {
      postNative("setUserProperties", { properties });
    } else {
      setUserProperties(getAnalytics(), properties);
    }
  } catch (error) {
    console.warn("setAnalyticsUserProperties error:", error);
  }
};
